<template>
  <div class="post type-post hentry" id="post-2">
    <h2>
      <router-link
        to="/2011/02/sakieciai-susitiko-su-gediminu-vagnoriumi/"
        >Šakiečiai susitiko su Gediminu Vagnoriumi</router-link
      >
    </h2>
    <div class="comm_date">
      <span class="month">Vasario</span><span class="date_nr">3</span>
    </div>
    <div class="entry">
      <p>
        Vasario trečią dieną Šakių laisvalaikio ir pramogų centre įvyko
        Krikščionių partijos Šakių skyriaus suorganizuotas susitikimas su Kovo
        11-sios akto signataru, III-sios ir VIII-sios Lietuvos Respublikos
        Vyriausybių Ministru Pirmininku, socialinių mokslų daktaru ekonomistu,
        Krikščionių partijos lyderiu GEDIMINU VAGNORIUMI ir Lietuvos Respublikos
        Seimo nare, Krikščionių frakcijos pirmininko pavaduotoja, žurnaliste,
        laidų vedėja ir muzikos atlikėja DONALDA MEIŽELYTE.
      </p>
      <p>
        Susitikime dalyvavo kitų rajone veikiančių partijų bei visuomeninių
        organizacijų lyderiai ir atstovai, Krikščionių partijos Jurbarko ir
        Varėnos rajonų skyrių delegacijos.
      </p>
      <p>
        Gediminas Vagnorius šakiečiams pristatė savo atsiminimų knygą „Valstybės
        kūrimas – misija (ne)įmanoma“ ir atvirai papasakojo apie įdomius
        Lietuvos valstybės atkūrimo užkulisius, pasidalino mintimis apie
        dabarties problemas ir būdus joms spręsti.
      </p>
      <p>
        Donalda Meiželytė kalbėjo apie Seimo ir Audito komisijos, kurios
        sudėtyje ji dirba, veiklą.
      </p>
      <p>
        Svečiai atsakė į gausius dalyvių klausimus, betarpiškai bendravo ir
        dalino autografus. Laisvo Donaldos vedimo dėka renginys tapo šiltas ir
        nenuobodus. Dalyvių manymu, jeigu šakiečiai būtų žinoję, kad galės
        nemokamai pasiklausyti Donaldos Meiželytės dainų, tai į susitikimą būtų
        sugužėjusi pilna salė.
      </p>
      <p>
        Skyriaus pirmininkas Romaldas Damušis pristatė Krikščionių partijos
        Šakių skyriaus iškeltus kandidatus rinkimams į Šakių rajono savivaldybės
        tarybą. Apie nūdienos problemas ir rinkiminę programą kalbėjo skyriaus
        iškelti kandidatai Vincas Pulokas, Saulius Urbaitis, Daiva Dovydė, Rima
        Prekevičienė.
      </p>
    </div>
  </div>
</template>
